export default function SuccessMessage({ 
  title = "Questionário concluído!", 
  subtitle = "Obrigado pela participação!" 
}) {
  return (
    <div 
      className="text-center p-5 rounded shadow-sm border" 
      style={{ background: "white" }}
    >
      <div 
        className="d-flex justify-content-center align-items-center mb-4"
        style={{
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          backgroundColor: "#28c76f",
          margin: "0 auto"
        }}
      >
        <i className="bi bi-check-lg text-white" style={{ fontSize: "40px" }}></i>
      </div>

      <h2 className="fw-bold">{title}</h2>
      <p className="text-secondary">{subtitle}</p>
    </div>
  );
}
